import { Mail } from "lucide-react";
import { Card, Spinner, Toggle } from "@/components/common";
import {
  useNotificationPreferences,
  useUpdateNotificationPreferences,
} from "@/hooks/useSettings";
import type { NotificationPreferences } from "@/types/settings";

const emailNotifications: {
  key: keyof NotificationPreferences;
  label: string;
  description: string;
}[] = [
  {
    key: "emailCommissionSettled",
    label: "Rozliczenie prowizji",
    description:
      "Otrzymuj e-mail po zatwierdzeniu rozliczenia prowizji wraz z zestawieniem w załączniku",
  },
];

export function NotificationsTab() {
  const { data: prefs, isLoading } = useNotificationPreferences();
  const updatePrefs = useUpdateNotificationPreferences();

  if (isLoading || !prefs) {
    return (
      <div className="flex justify-center py-12">
        <Spinner />
      </div>
    );
  }

  function handleToggle(key: keyof NotificationPreferences, value: boolean) {
    updatePrefs.mutate({ [key]: value });
  }

  return (
    <div className="space-y-6">
      <Card>
        <div className="mb-4 flex items-start gap-3">
          <div className="rounded-lg bg-adara-50 p-2 text-adara-700 dark:bg-adara-900/30 dark:text-adara-300">
            <Mail size={20} aria-hidden="true" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-main">
              Powiadomienia e-mail
            </h3>
            <p className="mt-1 text-xs text-dim">
              Wybierz, które powiadomienia chcesz otrzymywać na e-mail
            </p>
          </div>
        </div>
        <div className="space-y-4">
          {emailNotifications.map((item) => (
            <Toggle
              key={item.key}
              label={item.label}
              description={item.description}
              checked={prefs[item.key]}
              onChange={(value) => {
                handleToggle(item.key, value);
              }}
            />
          ))}
        </div>
      </Card>
    </div>
  );
}
